import React,{Component} from "react"
import moment from 'moment';
import momentz from 'moment-timezone';
import store from "./store/index";
import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';
import date from "../node_modules/date-and-time"
import { RadioGroup, RadioButton } from 'react-radio-buttons';
import Row from 'react-bootstrap/Form'
import './index.css';
import { updateTimeSettingsOneByOne } from "./actions/index";
import { updateExactTimeSettingsOneByOne } from "./actions/index";
import {update_Is_Exact_Time_One_By_One} from "./actions/index";
import {update_Steamer_Drifter_Settings} from "./actions/index";


const showSecond = false;
const str = showSecond ? 'HH:mm:ss' : 'HH:mm';

function minutesToHHMM(mins) {
  if(mins<0){
    return '00:00'
  }
let h = Math.floor(mins / 60);
let m = mins % 60;
  m = m < 10 ? '0' + m : m;
  h = h < 10 ? '0' + h : h;
  return `${h}:${m}`;
}
const spacer={
  height:'5px'
}

const marginRight={
  marginRight:'5px'
}

const inlineBlock = {
  display:'inline-block',
  width:'50%',
  color:'white',
}



const timerSize={
  width:'100px'
}
const timerSize1={
  width:'100px',
  fontSize:'12px',
  color:'#666',
  paddingLeft:'5px'
}

function getTimeDiffInMins(timeDiff){
  var hours =parseInt(timeDiff.substring(0,2))
  var mints =parseInt(timeDiff.substring(3,5))

  return (hours*60+mints)

}



class SettingsElement extends Component{


  constructor(props) {
    super(props);
    console.log(" props values :: "+props.value)
    this.state = {
      settings_value:props.value
    }
    this.syncWithCentralStore = this.syncWithCentralStore.bind(this)
    this.handleChange = this.handleChange.bind(this)
    //const unsubscribe = store.subscribe(handleChange)
    //unsubscribe()

    store.subscribe(this.syncWithCentralStore)
  }

  syncWithCentralStore(){
    this.setState({settings_value:store.getState().StearmerDrifterSettings[this.props.id]})
  }

  handleChange(event) {
    //console.log(" Settings Element :: -> onChange :  "+event.target.id);
    //console.log(" Settings Element :: -> onChange  "+event.target.value);
    let payload={}
    payload.id = event.target.id
    this.props.fieldType === "float" ? payload.value = parseFloat(event.target.value).toFixed(2).toString() : payload.value = parseInt(event.target.value).toString()
    store.dispatch(update_Steamer_Drifter_Settings(payload));
}

  render(){

    //console.log("Settings Element :: ID ->"+ this.props.id  + " value : "+this.state.settings_value);

    return(
      <div as={Row} class="divMargin1">
      <div as={Row}  style={inlineBlock} class="textColor1">
      {this.props.label}
      </div>
      <div style={inlineBlock}>
      <form>
        <input
        id={this.props.id}
        type="number"
        step={this.props.step}
        pattern={this.props.pattern}
        style={timerSize1}
        onChange={this.handleChange}
        value={this.state.settings_value}
        />
      </form>
      </div>
      </div>
    )
  }
}
export default SettingsElement
